import { useCallback } from "react";
import { readAmplitudeReplayId } from "./amplitude-provider";

export function readAnalyticsSessionId(): string | undefined {
  return readAmplitudeReplayId();
}

export function useReadAnalyticsSessionId() {
  return useCallback(() => readAnalyticsSessionId(), []);
}
